import gql from "graphql-tag";

export const GET_VENDOR_BY_ID = gql`
query getVendorById($id: uuid!){
  Vendors(where: { id: {_eq: $id}}){
    id    
    name
    vendorCode
    profileImage    
    city
    transportation
    bankName
    accountName
    accountNumber
    ifscCode
    createdBy
  }
}`

export const SEARCH_VENDOR = gql`
query searchVendor($search: String){
  vendors: Vendors(where:{ deleted_at:{_is_null: true} , _or:[{name: {_ilike: $search}},{vendorCode: {_ilike: $search}}]}){
    id
    name
    vendorCode
    profileImage
    transportation
  }
}`